
import {Component, Prop, Vue} from 'vue-property-decorator';
import FormGroup from "@/UI/components/common/form/FormGroup.vue";

@Component({
})
export default class ServiceCosmetologistLoyaut extends Vue {
  
}
